"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadOptions = exports.CAMPAIGN_CREATOR_LOAD_OPTIONS_FAILURE = exports.CAMPAIGN_CREATOR_LOAD_OPTIONS_SUCCESS = exports.CAMPAIGN_CREATOR_LOAD_OPTIONS_REQUEST = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var Sentry = _interopRequireWildcard(require("@sentry/browser"));

var _middleware = require("../../middleware");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var CAMPAIGN_CREATOR_LOAD_OPTIONS_REQUEST = 'CAMPAIGN_CREATOR_LOAD_OPTIONS_REQUEST';
exports.CAMPAIGN_CREATOR_LOAD_OPTIONS_REQUEST = CAMPAIGN_CREATOR_LOAD_OPTIONS_REQUEST;
var CAMPAIGN_CREATOR_LOAD_OPTIONS_SUCCESS = 'CAMPAIGN_CREATOR_LOAD_OPTIONS_SUCCESS';
exports.CAMPAIGN_CREATOR_LOAD_OPTIONS_SUCCESS = CAMPAIGN_CREATOR_LOAD_OPTIONS_SUCCESS;
var CAMPAIGN_CREATOR_LOAD_OPTIONS_FAILURE = 'CAMPAIGN_CREATOR_LOAD_OPTIONS_FAILURE';
exports.CAMPAIGN_CREATOR_LOAD_OPTIONS_FAILURE = CAMPAIGN_CREATOR_LOAD_OPTIONS_FAILURE;

function loadOptionsRequest() {
  return {
    type: CAMPAIGN_CREATOR_LOAD_OPTIONS_REQUEST
  };
}

function loadOptionsSuccess(payload) {
  return {
    type: CAMPAIGN_CREATOR_LOAD_OPTIONS_SUCCESS,
    payload: payload
  };
}

function loadOptionsFailure(error) {
  return {
    type: CAMPAIGN_CREATOR_LOAD_OPTIONS_FAILURE,
    error: error
  };
}

var loadOptions = function loadOptions() {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regenerator["default"].mark(function _callee(dispatch, getState) {
      var response;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              // debugger;
              dispatch(loadOptionsRequest());
              _context.next = 4;
              return (0, _middleware.callAPI)({
                method: 'GET',
                endpoint: '/wp-json/acf/v3/options/helix_campaign_creator'
              });

            case 4:
              response = _context.sent;
              dispatch(loadOptionsSuccess(response));
              _context.next = 12;
              break;

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](0);
              dispatch(loadOptionsFailure(_context.t0.message));

              if (process.env.NODE_ENV !== 'test') {
                Sentry.captureException(_context.t0);
                console.error(_context.t0);
              }

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 8]]);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
}; // }


exports.loadOptions = loadOptions;